import { Injectable } from '@angular/core';
import { PfeStateService } from './../../services/pfe-state-service/state.service';
import { PfeUpdateStateValuesActionConfig } from './update-state-values.model';

@Injectable()
export class PfeUpdateStateValuesService {
  constructor(protected pfeStateService: PfeStateService) {}

  public executeActionUpdateStatesValues = async (actionConfig: PfeUpdateStateValuesActionConfig): Promise<void> =>
    Promise.resolve(this.pfeStateService.updateStateValues(actionConfig.stateUpdates));
}
